const time20201019 = new Date(2020, 9, 19, 11, 59, 0).getTime()
const time20201023 = new Date(2020, 9, 23, 23, 59, 59).getTime()
const time20201030 = new Date(2020, 9, 30, 23, 59, 59).getTime()

const availableCountryFor20201019To20201023 = ['TW']
const availableCountryFor20201024To20201030 = ['TW', 'HK']

const homePage = 'https://www.citiesocial.com'

const lineRedirectUrlMapByProductId = {
  4551049150577: 'https://buy.line.me/t/?data=TKNAO27ozU3vf50Jir7ibppIbXrFmx3bBVBI78b6KKpTNw_yxhsweOHkeCLHOltHORxpsTRVuxpK4FvtetXFIfYCAL2WcbnWlQ5TguorzQ-fbQX_YGe_QqLzkJC7qIJg957jbYM3uyhhOoYQ7hlvglEN48gwfnv3nHdrXfivwMEFhsvj4pYxP6Woy713vq8cStXLj1B0bGaTC_TQCPZZMYggk6kys9Buwq201hyyKRuZr7t8GLmsVGJMcl_bzpN92PaZhx8gBnrnGhi0C-FPBJp9fCnTYTTDx3h6_C-Vh9x99_NUgg-pkT8NtR3tShI9opgPn6Xxb5egcYUFn9zo8E3TCcm6sED687UouJC8xryYPfkK0I1ngnMo4rCB73vzOYZ9xLoHlGWzxftAk2AhhCf3pNogduNluuz1o8PNKDUI',
  4583816626289: 'https://buy.line.me/R/t/?data=tewCQbXuxPyQAmTS_MB9ehYi7856O5Q8P6bZKHZXwnQuHvqnzmFFIJmvO1MRPjd6snefr1URDZuyFW3mMddipwmEUpl9ud67jX30ZbhKN73Sf1CvSS3HJfvPEgO2gEHrqFjJsiF08AcOj3jOr5VfNzMqwSp0OnGQaexDGkD9VMHkElYyQrUBB2ttYwGM6k6Sk_YhzV7oXg67zILSb95yq9cuwZ1ZqVoRACMFhv9bwZ5-SbWGlriDxWq0ecIoqW_8i7lGZpIf0rz0cHhkw_ZNhkb1tdbWWe8Orn99THj-favzeS-CVt2Z9WEC9jMDaUDrIHT1rA7w2CeU6tY2L1sl2aol8O4-RleYd6DLdckFPuSz7293HjbUsv2Q6UTZI3Rgm1O0ugN9mxB-Pe21zDAdpSqeD1riNAIxWKurZA',
  4536756895857: 'https://buy.line.me/R/t/?data=ZInvoQYvVY-llMXf57rlIM5-KcdqCZOjQsPaXyfI7SbctxpY6tZP-nd-0yfOQ6Ip7xOL4030un1vyA56FdL0xduomGpKWNDGUB1-Wq3Jru2T7evvUw-a5LYwSbpbmdMnCa4Anbyg2DGzd4uMhzopCN0pwnU9Zz2a9nNJkc8PBi8LFQgazWDeUpBWBLee5BZyKdKuvBLU9WeTz0geEX7yTwGYK_tetM2LYJTkTfrRZZRn5tQkrsz2yVqr75U2f5rFWaZeco8JZ5dWU4SEkBaAxMqIc8JRW_LoAUm_jaocFmIwvHYMIC_pj2sFcjCZwYU4BusMQJGc2Q7r0nn_TsBbbx0t-MxeJLpYItXnwqzQVBa2VVWva5DioTZDMIxLF_P607bLC0SKjNSGinAKaSDqw_6xNJ9R4KAqjpeMHMDh11p_BNQ1SQ3IXiMgbotMDKAadibuibQ6jO9IkZcvmVxFalsBA1FdCSbGcPCboFOCwCDsypX8EEjMKTDltoFPiLvdRM8PJQknKunONnzOJW4cWZkdBoCdnCZW',
  4578563883121: 'https://buy.line.me/R/t/?data=6SwffICbeqGJwEP0AR0zkmXPy-3Uh0536YS5D6KoVNLuwQJVEldZ3oWIiiEc-ws_ARllqhLmtyyWFk26cvkRkRbjiKUs5yBOomieLq9A0PxAUYlOA_nWp-Blpl91Ah5lFldSU7JxfAAOPudQ0EhMhSy7tKn0CEa3DAWPcKhFun9hBMvBMCpv43H4kAAB8xGOY7NOUtHPvlfIAEJSs75lRLUt6oSvkXzPCKeDTDk4GlZNXz-3baMJ9Lp_53EJCMrDTJJqUg',
  4584149352561: 'https://buy.line.me/R/t/?data=jN0QSejyOuTySSDgyT9L_3c6qP0RAqM0ncK19PmvDG9xsa767uYiI5JxiGqbQBjqbXfDZt0b3fIqnr9LsnulbioSMwUrKBEKu8UaA583-NQTy8rQFW443Ojnqk5L34hofaizFVlWeiAWVjevsRKXBc1SlVlj4uH69o_Ibz7iV5U-r3qyEsO_sjMSIC2HsRGvCkTWm-mhBbNBvI181_EsLjGHjtkXAyYi8u3S63-SmoxBqa8mwLSiN45cDgx1tzlXN2gCLNzNFw',
  4579466444913: 'https://buy.line.me/R/t/?data=AhZ0opFrn3_ucWvTg7-R9Rq5G5TmVuabJpnsL42MWfB9l2q7mVpKW_rwDN_EwoBOjNTpbAoEboXiX3XqrIsGjUnWyid1dA97oqvVflzEQbYunnrOEf7HQeHQEeAEblsg52IkQsHR8FoTvY8TzMOwVuSIrOWYiIOopa2WQP0V8A6w52bxYtXdcKk2qCA7WohDTFAVJHHRklAYUghXoqnDWAMqdKKWw1EGIyuAz2TFzKX3t00-6gtX67Bl1NpWSZqm33iCC-EuaKxY9ErMInxC8wvujR9J71_Mw-83V16NHESo0LO0zkmdpBTM3f_W-Vy1fLw4UCIm1nItJJvQbvc0M0rkV146wcn-gZTMNb6kqU6C4QDyNBqizsas45BudBArB7Jg4wSUo7r_4nTvihYTdSwZbMabhiGxTMZFpGjj9F_SFw',
  4565831188593: 'https://buy.line.me/t/?data=Ki0fqz13gTHgTDGURJv3smidRvLp8ilQethuQVlTORtc35UbOrLoUeb3urFh4KTE9Rv-yeb521M4d2M9kuryO803w6zV5QPLb4kMNlNA8jG5s7Hit-FIZZ6yvsBs_t8pUjnr3e2CU9LZMb9qMh1am525DTh-a_Q9Pt434O-ry-AFlEtQJeKKAMLIDPV_O1H0O2nnuTAqMIYIbq2BFJB64Ro2xAGy6Xo3mITHgc7b-cZ5RVzn-iQ3bn7cTAusT47tNHCrm1PPC2gVfOORohLQTazn8R5dcHDkHRoPEyfGN3BWaHOM7E-OLYQOpRYrWbWp8tlte6BlQnUyBR3WUMa5KGOS2mjrrzfnwtq3pCvkXfoxmmKCTFgCoGNvG6jMsyxLtt_3iC0KHHFX',
  4576582860913: 'https://buy.line.me/R/t/?data=uE57VPw-w-UZowaGvG74o6rgJGL0ui9uZfwG0XTzIFeNnzdJae6XBxK9cgz3rOfjB56eCa82-h45KwjvtX3ScK83tM04s-yYYwPYoAQp4pGH9a3QOrFhexEQk06tm2PH88eOW4RpRvjbhF1q40xo5WiRvd_wDPvtlpclht3OkJBd4NSJuglNvej6jUEymxdqHB11PChs_SEG2r8akKsCxBp_QNwUwgLyO9G93ZWzbpr00_ar--3uPPr6OtP09ebbM2yhjlPW5blvZcSBug',
  1933887799409: 'https://buy.line.me/t/?data=Wdb9lGRkjb1RBeV2R5Ul14Doj-5wviujxpfYRanJg2yN8L9pLw--mF1hwXYqk7jeXBFZANLlZxQ7HdZix8VGICjANwQ1cy0WVJLOd2MPyyoSmbY4NTe0F64nWGmT5Kw-SNKIsXeky8_gWi7J7eEG0VJxzl0BkYxl1Mm1D4P3kNW4u_i7D_6D8cxb44AhfTzZ9izBPMu5gIID15LWMQWsvz9EBpm39nhXA8VaM8jJf_fxBaCtDxj6iAfP6ccP_IPRAXqQJKg',
  4579496067185: 'https://buy.line.me/R/t/?data=tkb36vRh3vZEGcBL9roat78WLYyAFV6MOZb037lJUFDXszJ35oFUvHGWHivJNkCnywtwpwFB9LeKB3LAsAg-kVPH0P2-lZq2BdNU2x_m3wmHTm1UauMHDOj1k7ujf0ouGqStASWaf3cZDwW6tPn-NbVmYR52XdN9pvY7At8TzKtr7dda8J4viXg8JB_N9tnnAkWrcRfyudrdaN3tOLsp1roGbbYniJFZvlENTvFWiJMR9iV4cGu9wuMDtBGG7VBdUe09wGgHXIf19xIKjXo',
  4577188872305: 'https://buy.line.me/R/t/?data=xY34iBJsH-7yedBQjvUDkPXUN2JyzPlQJ66BDf5IS8v3sasCa5kIVqPOKYSrkZ6W-Ob8yARrEuEw36Kps6_po45OJFIWRmVYulk8o0sNDtTTOC9xsdsvAWHQVifmfslikybh1bFdYUYJXiP5Yg73C1XB2lyQZqOOrnGqmxqDtmRmL3b4jTQDzc_hX_EfsFIRrbPwFH6yDLYgf1BX6rrOFIZWd6NQR15NgTSGCGV3msNG5yCGD_udVlXktJgmE7HmviRh2NFe2JGQ',
  4501952430193: 'https://buy.line.me/R/t/?data=cFzKePlFn8hsAwvfYVfk2O8v5A5qS4hilLjW3izVvkf1Yhfpb4LFAereRzYCiZmgOJeJRxRn7xYQlAuqGfUJ92mehGZF8EOv4OCFAZv_H3-T6eCF6PyCgetZzCBSqlLo7_3FVlr375PvfhgR9mVK5WA2lVhwITUt61GazjwN1I5HDRXNv1MDo7QIf0PiM_-8_lfidvb2KqwFOAIITlJEZhA2o3UPqo9aNxNw6Ll0hL-BAFcRrtDIbFvsd9VkZLdu_dtS9f6Po16C1WgKiY6gtZTMzS4R8K_gtMCUCmWO2hBTGd7O5np14MSkmNnEf04AqnPsD8lnHb8sxgXt',
  4584214790257: 'https://buy.line.me/R/t/?data=sS5RnAM_yQXTJgOQ3-1W-SAjAY65JE7xQAZmY--JFix7389xswcClMPfwFEs3aj-BDDtKFO8oV0Ftl9I3I_k9T11KJqvPHWHqXlfmcgAtkZQnhNQXi8-mhpIy-5N43gf9BoSbHfS5nnXd-4gC6x_OmRv0h_yiXrqhm1ySbm6Og9NL72RV0Zymuz0ugOC8cUrXDWtdc-H1rniqXhButGOqGe6QvyQvXa0MY5CYGvyZPET9asmcaIJTX0dm8BfEWGZDGYgzOy9j1GlYNxsVTCIlvP52A',
  4584061468785: 'https://buy.line.me/R/t/?data=s7DFugsJBGe3SNDv7s7lULuOW8wFiyFyWJ7JTYEdof86chx_e8oL8-BrpTSuHXMq27B4z8oaXyByZnk0RjdLWLxXuD7Zu-vY2dyta7DbV396tSj0ucm0jrmFOIVXa6tWp5hbuGRpk-CuMu1MxKPLgvPsE1_E8o4ZMcTPfPp32iwuPmz-RP44W6AKRwbGHwzIjMPjIjJn9SWmGlaHIayuIp1HulPfP4JdpZQcN4t70Uoh9HDeXlRKF4-RNIxroPi1dD8uC8n9o9p-kow2cEVaap81mwkTy5sB50kGQ8dQp3780U8SpIKI2C5nYTOurkTWfujMTej_SN-XKJxZpja3H1XlDPuKDjMoGKUpwkJuX6vacuaUl4YqTUxfLOcMJI4Hcr-QphezIVkka5q_v3PdlJ2LSZEgCN7oXMnqXEPonpaSuS9N8kWTQ-0dNeIeuoA711s_VYO10JN8ifQNPrDPPIqpBuJBxwX7zPB9UYljVJs',
  4388097130609: 'https://buy.line.me/R/t/?data=mAKh6Lsda8-KyW2OwHNgbvE5gw8yRxztTSeMYmG_nEF8_OeaMNdomI7BAYl6PEhUj7tpt-Ug5-embPfUB_EOsFhepUnAsfUXT8FkyIQIXjgEB4Gq5iTm15lpWLlciogV91qlDQD-AGBIcRhtW6gMuOH6TLKgMSwGWuxwyK6wNqSENhyDCJRBYwwoviiofxT4esSdxR7flEvWhwdyVMVY_IxECw2x6zjanOGH2usVQHLVzvB6llxtNmQ9KbJYqbd3_C71BF0937B7wkxaUijz17rsGM-wLuMHCAeCmAvNePBBRr6ryMEF863-THAZkLsFpGBTPstay21xrDZ-I_1es_pBaJtAr2WBGHORWuHY4IU',
  4579497443441: 'https://buy.line.me/t/?data=Ru_eUA7IkwuxH-pMZpfDL1JJsmWuPQYBrHF4WCVJqtaRMlg0Lv7jH17EQ436k6kCa3rrZpaFxvNGd_PK-jnwb0pf1cPP0l7zAXgwbnONt1azUfXSePmvuBmJf4h_3UYi53C5kqO-yPpUHhXA6AfgmSbxen3OqfNaridUGcziCjj0fwkjEfVY5mZzMubeKxuTiFHt3pAnD87Mn8dkY-i11RvDjQOuomHuNeuxAxd8paPuWgmUhV9omPICu1iZLwMy4tR_st1GutadyqxD9D0uhQMCoSVlVkMG20GW95DEFuaUIvhE1nUpI9wDF_yLUvlskznWC5a_awaAnRCz4I6ulPSdIkzu8d_zYmUG5KtOAqY8J96xDeqPZZ0',
  4584061010033: 'https://buy.line.me/R/t/?data=W3o_C8KhwINmMGpegDgjkV5CtbcC0LTtDTfyW9YAs9vXH34KiUgndz-AuJetiEjw334UWdoSQJu7Ix32UWz4D4SOsPBIocqyLdmyKDda7DzmQeoARVz5Ji-qrxqtOp0HSyJ9iohoPFPcJDYYaojb0LZ0xP7jLAbDKwZm4ivaJiExixtIPQYyz_WmB9XKcufCelA3D209PDN65tR17H2wGY8kb00N-GKOOjFjv0qgvQgpCfb1fWgCYC-zBLKVd5hl5QnRaFCUZEfyOoK8YYY_2-88GMu_FWiFz9cyUWP9daWEhN3Osx4OF3WjFhKK92lcqCbDmx5tuG7CbgLadzxp4u0s1nYmTwT0jWyxr45yjast0YMNDewtS2gnhYsrs1IUFko7Ptw0wdru5vPNHO2XrE59qxVZMG9ZLx9UH-bf4XDHVLPpw29hrS1tTrr1roXDVBB3HAHb9g5WMKMwXkY1rNLdsVC-d7efPI4xClne3c3wJ3zCkzUxiQ5UNOrs7rj7vW16LAf2nD9lFbJI9ZDd7lylyIJfHsPaDPgTT6K-nrdg2Wnd8KZZUggVblAx8ujTZvf5n7GpQjIVqw',
  2359482974321: 'https://buy.line.me/R/t/?data=cWNU3P5xx-Oi2TeNfYU8s4QD_CAeYzXN7x1iPFFVFsZAiPeUAP5PDAr8e_dyK-dIkvnswaaRNslYu3-1EksByzhN6MccDAWZPvAfK2WVqWwZnrpoaWL0RS_-ftx-zIjgdnDP-_HmVvWiGwF1oq6-f3k0hF0gojMirPyMBOsgp0jsBUlStbBoNuzbA8n2Z_q1IXisJp_qXPXjZNBZDuVRFlN3fTqKAZ4J30CbtEKUsDsXB6vHbXqUzMXBiSmqGRgEMuPjgpRcXA',
  4583348142193: 'https://buy.line.me/t/?data=CyfMniiIG77lsu_N51k50RvqVl8vRwDxxpZjTBnxOXypeDYDZBaoo6a5jS2T6X6Aj6FJFW8k_nTSAAtLFPbO8O341Wot5soNw66WeXU-wsKU7Ph2K0oHZDHrbu42MHJs34pZ7ApyrtIE5dBNWAqSwJkrsnZgqCt2JcxeMYbZD4qR_4aTlQLmE3du8jdEoBebMhW2MHWAHh2zNolfoNy8Mb6P3Qel7pE0YS61wmeZJpiQly679JqsB32Ec5OT38OiNg-GZUPw7s_IbYfXRMCsJOIFSX960MPkPBMmkoM7J6zubfNjQSPUuU22VmP-6luCeKo0jbPhmtHenW8O0bCFs6wY4TlmMNla',
  4348097921137: 'https://buy.line.me/t/?data=DkAv_JnBMZ48eWtsilQz6HG_zz9K_TQbStFuj6n_oSHCooYVVmGNoVh9XLwX48mNcjP6DWg1VrZf0mTfoSOsiXZWplP-VD2u_DidZ5fVfAI4j0UAby5ujOuVY_F9NNkt1SGGDKD2x6M59p4mjFzGuRFUiCMxvYBGFSR-TyA7KtPK_iHIzY3Dx0xeABxMdo4rrVvE1WZTU9SNTiZlpzbv20_3BDVrNLpsLvZ4RnNpRSQzvYxmRkxjU9UTlJ--KLn2Sp-z3iIY-lHeUAJAcxeRNH49BlYALj-p1loMA2B-brLC2CjtIA3sxt6DusStoiuIpW8DEIxauzfnLusS9v3aOPXaawL_eXeffSnjrvfCKQnvRIb6ce3qAZHP5Y4AgKU',
  4512340344945: 'https://buy.line.me/R/t/?data=K9S8p0CWUxd8DKjjOEZNS6HoIsUERv0ncEumFIiKh49hlRiQtKWhmjIVYcJx8v6aaSRV1EdJPK3SDDR5o8dYlAAdKA2Np2t6SQP7EqDOpQ67Zl4FQiz8_FH-LwtOAc_x9oaQDXk9STdSiXXLuh8sBXFidPD0kyUehweljVyGW3-f2omLt9gHgyhsSBDkJudtnZPrf0JKnRMWzcVXs7EWRmyHDXHtDel9FcR_MF4EaRq7_C0Q3zEQ2I8Kx_zGLDLucHaUOWG7FFPx4FD4jIMoJzmyaKWPStyoEzJkn8zjzQlY-njmP2xLOI79iLYHjVBnG0YNL2ioDmmdxLepa9APneojSTA6nWW1JeuQor7LIYc00sNJM04k_8VOOg2fgK4KC8ECAU0m6ErJhpCtteUtHCRUPAp0wm0NEMj6o7zmaFmGx4dFGC2KrHl6M5tJJc8',
  4561533436017: 'https://buy.line.me/R/t/?data=0WLNb1oTSxPsrkqGVipyvx0ZS0UvYVHhKuUhqhL8CAfYnr4CTTnNEU0rcoLTHDSE8TwK-4r1dh7UL-tUWcnVH4JypTqFd_jymMZL_iuNPzxIZzhzPW6JirpafpAmABqJz4BV2wxzS_CUCZIKYhG_i-q2ayzfJk89evh_DPCZsIE6RssXfLISyMIXHkNp-NrlwMLymNyHb-pVh6NV9Rcb8vz1EYBkN4zfY1sBe03H2EAYunZsdkVgQ5Oa7y6xq2PWmiXftDcZDUoRXBo6IELk3s0wAZHqtjbSMYmqp0-AfUlmFOrJo1HyzIzxwhfZbTw4RZ3X1KfTaFAsT-7vysMJsyM6orFljpfvHTQ5xhft4w',
  4583373308017: 'https://buy.line.me/t/?data=AffupGGvV3Yr5Cp-WuRJIytAr9gFq_Ay6RDnqDzE6YOmTNFjCQeyiM2kQVfsu4HrqkVKaNR3JVWIrUI82eo52D_3_zA0Mv31TB_Na6wrN-1z_iG5qiW5Kc45GqwFZDI0HwKHiAGOLDYkcJb8mPLQr5eRXcOHUGrFIz7tnZ05Ai5b4nLjg_6BhDLt44-TUlMVmUO3Bz_dbDS4AXd2cQpa8cztgL_xgg6teAlVgEz_7WOkIOZO48ZwIKMNU5atWUkcA-JHdClIy7RmFjKjiOtbc0fTZjVqsFy0m6aefYo09NZnU62YHronWrHN0q9dfFIi-7UZEJ7PPTkB6l4CKpelFlpi4ZNLv3qx-wM',
  4569480429681: 'https://buy.line.me/t/?data=rbLZzjZKT280VmWqE0HUmVNS3IIuiqkIf-qg9xGFyt_4aITujljczXl5ncNe6UzieMlqQaXKP5_kUfSsTCFgnJzgElKDyOzUQbF5GkziuJewDv3s9fcBnXWwnBwTN6fE_dVu6EBcXGMZs_rx254b6Lbm4OOIx0wJ8HozuI0ZTod6anT8MHQdtSbt0DiCA4fFcN1Jv0aFpKdRsE_hBcpqfYNAvi6G3ioVWtOEMWvXGReNgX7aXnsXPNZT1Rs2Ibk2tIDUtLoFv4Cr6fTQ68tDg0i4o1swjhKiIHpezuQhTSE',
  4448002474097: 'https://buy.line.me/R/t/?data=r0GzsIJV4KzpoXU__FLZJlbI4RHzhgbhAF6zgcFc0dgDhE-syXsxYsWrhY84dQEAZi6Dx3unBFrQZ6EQwAVwYEs6gL2josNZoAbmolNYSyJfUi5GPxrPi6Kxg2_INdyjoAAKpysO4rS6UCFYXgT1-sflNAKoawpbqdwIWcrlx9oqJYe3azNs6Jiqbl_4VonrCmqAXSl3q5lSmuAiBYRrzIBtPcqGIbLvDD18LsA7YjwN4tqTiomK9kSz1uMtGwJm3NgSGUEMGlB52YmqIInGAXAkpJawm7eRSINLbNhZ-VCyXAP7gmb7Ffrbh4nFDPeZPmGv18Fu2bqN6SQDzwReQ9r2arohPdHi7wbqfAz0uf7MbHuPfCUoJqpyBAXROS2d70ToRDrlqkX1k2ces0d7JKKNWznCo3E',
}

$(function () {
  displayNavigation()
  displayLineTrending()
  displayFlash()
  displayBigTopic()
  displayFeaturedTopic()
  checkDateToDynamicShow()

  function displayNavigation() {
    const headerHTML = `
    <header class="anniversary-2020__header">
      <nav>
        <ul>
          <li class="js-show-only-20201019-20201023" style="display: none"><a href="#line-trending">LINE 爆品</a></li>
          <li class="js-show-only-20201024-20201030" style="display: none"><a href="#flash">當週強檔閃購</a></li>
          <li><a href="#big-topic">熱銷排行榜</a></li>
          <li><a href="#featured-topic">精選商品</a></li>
          <li><a href="#bank">銀行回饋</a></li>
        </ul>
      </nav>
    </header>`;
    document
      .getElementById('shopify-section-header')
      .insertAdjacentHTML('beforeend', DOMPurify.sanitize(headerHTML));
  }

  async function displayLineTrending() {
    const collection = {
      collectionHandle: 'anniversary-2020-line-trending',
      collectionId: 163482599537,
    }
    const products = await Citiesocial.productManager.fetchProducts(collection)

    const productCardsHTML = Citiesocial.productManager.makeProductCardsHTML(
      products,
      collection,
      {}
    )
    document.querySelector(
      '.line-trending__carousel-wrapper .owl-carousel'
    ).innerHTML = productCardsHTML

    const owlCarouselOptions = makeOwlCarouselOption({
      dotsEachNumber: 3,
      middleBreakingPointItemShowNumber: 3,
      extraLargeBreakingPointShowNumber: 4,
    })
    $(`.line-trending__carousel-wrapper .owl-carousel`).owlCarousel(
      owlCarouselOptions
    )

    changeLineProductUrl()
    const targetElement = document.querySelector('.line-trending')
    convertAllLinkToOpenNewTabInElement(targetElement)
    function changeLineProductUrl() {
      document
        .querySelectorAll('.line-trending__carousel-wrapper .product-card')
        .forEach((element) => {
          const productId = element.dataset.productId
          const productLinkElement = element.querySelector('a')
          const redirectUrl = lineRedirectUrlMapByProductId[productId]
          if (redirectUrl) {
            productLinkElement.href = redirectUrl
          }
        })
    }
  }

  async function displayFlash() {
    window.flashCollection = {
      collectionHandle: 'flash-collections',
    }
    const products = await Citiesocial.productManager.fetchProducts(
      flashCollection
    )

    Citiesocial.utils.shuffle(products)
    const productCardsHTML = Citiesocial.productManager.makeProductCardsHTML(
      products,
      flashCollection,
      {}
    )
    document.querySelector(
      '.flash__carousel-wrapper .owl-carousel'
    ).innerHTML = productCardsHTML

    const owlCarouselOptions = makeOwlCarouselOption({
      dotsEachNumber: 6,
      middleBreakingPointItemShowNumber: 4,
      extraLargeBreakingPointShowNumber: 6,
    })
    $(`.flash__carousel-wrapper .owl-carousel`).owlCarousel(owlCarouselOptions)

    const targetElement = document.querySelector('.flash')
    convertAllLinkToOpenNewTabInElement(targetElement)
  }

  async function displayBigTopic() {
    const collection = {
      collectionHandle: 'anniversary-2020-big-topic',
      collectionId: 163482632305,
    }
    const products = await Citiesocial.productManager.fetchProducts(collection)

    const productCardsHTML = Citiesocial.productManager.makeProductCardsHTML(
      products,
      collection,
      {}
    )

    document.querySelector(
      '.big-topic__carousel-wrapper .owl-carousel'
    ).innerHTML = productCardsHTML

    const owlCarouselOptions = makeOwlCarouselOption({
      dotsEachNumber: 6,
      middleBreakingPointItemShowNumber: 4,
      extraLargeBreakingPointShowNumber: 6,
    })
    $(`.big-topic__carousel-wrapper .owl-carousel`).owlCarousel(
      owlCarouselOptions
    )

    const targetElement = document.querySelector('.big-topic')
    convertAllLinkToOpenNewTabInElement(targetElement)
  }

  async function displayFeaturedTopic() {
    const { featuredTopics } = window.anniversary2020
    let featuredBlocksHTML = ''

    featuredTopics.forEach(({ title, link, cover_image_url }) => {
      featuredBlocksHTML += `<a href="${link}?ref=anniversary2020" target="_blank" class="block__item" style="background-image: url('${cover_image_url}')">
                                <div class="item__title"><p>${title}</p></div>
                              </a>`
    })
    document.querySelector(
      '.featured-topic__carousel-wrapper .owl-carousel'
    ).innerHTML = featuredBlocksHTML
    const owlCarouselOptions = makeOwlCarouselOption({
      dotsEachNumber: 1,
      middleBreakingPointItemShowNumber: 3,
      extraLargeBreakingPointShowNumber: 4,
    })
    $(`.featured-topic__carousel-wrapper .owl-carousel`).owlCarousel(
      owlCarouselOptions
    )
  }

  function checkDateToDynamicShow() {
    const timer = setInterval(function () {
      const now = new Date().getTime()
      if (time20201019 <= now && now < time20201023) {
        // 週年慶第一週期間，主打 LINE
        document
          .querySelectorAll('.js-show-only-20201019-20201023')
          .forEach((element) => {
            element.style.display = 'block'
          })
        document
          .querySelectorAll('.js-show-only-20201024-20201030')
          .forEach((element) => {
            element.style.display = 'none'
          })
      } else if (time20201023 <= now && now < time20201030) {
        // 週年慶第二週期間，主打九折
        document
          .querySelectorAll('.js-show-only-20201019-20201023')
          .forEach((element) => {
            element.style.display = 'none'
          })
        document
          .querySelectorAll('.js-show-only-20201024-20201030')
          .forEach((element) => {
            element.style.display = 'block'
          })
        document
          .querySelector('.featured-topic')
          .classList.add('featured-topic--light-bg')
        document.querySelector('.big-topic').classList.add('big-topic--dark-bg')
      } else {
        clearInterval(timer)
      }
    }, 1000)
  }

  function makeOwlCarouselOption(setting) {
    const {
      dotsEachNumber,
      middleBreakingPointItemShowNumber,
      extraLargeBreakingPointShowNumber,
    } = setting
    return {
      rewind: true,
      margin: 8,
      slideBy: 1,
      dots: true,
      dotsEach: dotsEachNumber,
      items: 1,
      nav: false,
      responsive: {
        [RESPONSIVE_MIDDLE_BREAKING_POINT]: {
          margin: 12,
          items: middleBreakingPointItemShowNumber,
          slideBy: middleBreakingPointItemShowNumber,
          nav: true,
          dots: false,
          navText: [
            '<i class="cs_icon icon-arrow-left"></i>',
            '<i class="cs_icon icon-arrow-right"></i>',
          ],
        },
        [RESPONSIVE_EXTRA_LARGE_BREAKING_POINT]: {
          margin: 12,
          items: extraLargeBreakingPointShowNumber,
          slideBy: extraLargeBreakingPointShowNumber,
          nav: true,
          dots: false,
          navText: [
            '<i class="cs_icon icon-arrow-left"></i>',
            '<i class="cs_icon icon-arrow-right"></i>',
          ],
        },
      },
    }
  }

  function convertAllLinkToOpenNewTabInElement(element) {
    element.querySelectorAll('a').forEach((element) => {
      element.target = '_blank'
    })
  }
})
